import { gql } from '@apollo/client/core';

export const GENERATE_JOB_DESCRIPTION = gql`
  mutation GenerateJobDescription($input: AiJobPostContentInput!) {
    jobPost {
      generateDescription(input: $input) {
        description
      }
    }
  }
`;

export const GENERATE_JOB_HEADLINE = gql`
  mutation GenerateJobHeadline($input: AiJobPostContentInput!) {
    jobPost {
      generateHeadline(input: $input) {
        headline
      }
    }
  }
`;
